import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { getErrorString } from '../../utils';
import { fetchPatientSubscriptionsApi } from '../../api/patient-subscriptions-api';
import { fetchPatientOrderDetailApi } from 'api/patient-orders-api';

const initialState = {
  activeColumns: [],
  subscriptions: [],
  subscriptionDetail: {},
  statuses: [],
  products: [],
  loading: true,
  pending: false,
  pagination: {},
};

export const fetchPatientSubscriptionsListing = createAsyncThunk(
  'patient/subscriptions/listing',
  async (updatedParamsObject = {}) => {
    try {
      const paramsObj = {
        ...updatedParamsObject,
      };
      const res = await fetchPatientSubscriptionsApi(paramsObj);
      return res;
    } catch (error) {
      toast.error(getErrorString(error));
    }
  },
);

export const loadMorePatientSubscriptions = createAsyncThunk(
  'patient/subscriptions/loadmore',
  async (paramsObj = {}) => {
    try {
      const res = await fetchPatientSubscriptionsApi(paramsObj);
      return res;
    } catch (error) {
      toast.error(getErrorString(error));
    }
  },
);

export const fetchPatientSubscriptionDetail = createAsyncThunk('patient/subscriptions/detail', async (id) => {
  try {
    const res = await fetchPatientOrderDetailApi(id);
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
});

const PatientSubscriptionsSlice = createSlice({
  name: 'patientsubscriptions',
  initialState,
  reducers: {
    setSubscriptionsLoading: (state, action) => {
      state.loading = action?.payload?.loading;
    },
    setSubscriptionsActiveColumn: (state, action) => {
      state.activeColumns = action?.payload?.activeColumns;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchPatientSubscriptionsListing.pending, (state) => {
        state.pending = true;
      })
      .addCase(fetchPatientSubscriptionsListing.fulfilled, (state, action) => {
        if (state.loading) {
          //means first time loading
          state.activeColumns = action?.payload?.active_columns || [];
        }
        state.subscriptions = action?.payload?.data || [];
        state.statuses = action?.payload?.subscription_statuses || [];
        state.products = action?.payload?.products || [];
        state.loading = false;
        state.pending = false;
        state.pagination = action?.payload?.meta?.pagination || {};
      })
      .addCase(loadMorePatientSubscriptions.fulfilled, (state, action) => {
        state.subscriptions = [...(state.subscriptions || []), ...(action?.payload?.data || [])];
        state.pagination = action?.payload?.meta?.pagination || {};
      })
      .addCase(fetchPatientSubscriptionsListing.rejected, (state) => {
        state.loading = false;
        state.pending = false;
      })

      .addCase(fetchPatientSubscriptionDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPatientSubscriptionDetail.fulfilled, (state, action) => {
        state.subscriptionDetail = action?.payload?.data || {};
        state.loading = false;
      })
      .addCase(fetchPatientSubscriptionDetail.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setSubscriptionsLoading, setSubscriptionsActiveColumn } = PatientSubscriptionsSlice.actions;
export default PatientSubscriptionsSlice.reducer;
